import React from 'react';
import { CHECKOUT_URL } from '../data/content';
interface CtaButtonProps {
  label: string;
  sub?: string;
  id?: string;
  tone?: 'green' | 'cream';
}
export function CtaButton({
  label,
  sub,
  id,
  tone = 'green'
}: CtaButtonProps) {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  };
  const base = 'group relative flex w-full items-center justify-center gap-2.5 rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold uppercase tracking-[0.02em] leading-tight shadow-[0_10px_0_rgba(0,0,0,0.18)] transition-[transform,background-color,box-shadow] duration-150 ease-out active:translate-y-[3px] active:shadow-[0_6px_0_rgba(0,0,0,0.18)] sm:text-lg sm:px-8 sm:py-5';
  const tones = {
    green: 'bg-kidney text-white hover:bg-kidney-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-kidney',
    cream: 'bg-white text-navy-deep hover:bg-cream focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white'
  };
  return <div className="w-full" id={id} data-id="element-29" data-mp="39zj1m12kmjy7">
      <a href={CHECKOUT_URL} onClick={handleClick} className={`${base} ${tones[tone]}`} data-id="element-30" data-mp="3a0kmex9e2kt4">
        <span className={`h-2.5 w-2.5 shrink-0 rounded-full animate-dotPulse ${tone === 'green' ? 'bg-white' : 'bg-alert'}`} aria-hidden="true" data-id="element-31" data-mp="3jwnm7wgrq7cw" />
        <span className="max-w-[22ch] sm:max-w-none" data-id="element-32" data-mp="3sxdj73hrm3s7">{label}</span>
      </a>
      {sub ? <p className={`mt-3 text-center text-[12.5px] font-medium leading-snug sm:text-sm ${tone === 'cream' ? 'text-white/75' : 'text-navy/70'}`} data-id="element-33" data-mp="1j7qeu1872bc">
          {sub}
        </p> : null}
    </div>;
}